package linkerpangoquipdb

import kotlin.Double
import kotlin.Long
import kotlin.String

public data class Spare_part(
  public val id: Long,
  public val server_id: Long?,
  public val category_id: String,
  public val spare_part_id: String,
  public val brand: String,
  public val model: String,
  public val additional_info: String,
  public val durability_days: Long?,
  public val quantity: Double?,
  public val unit: String?,
  public val signature: String?,
  public val reference: String?,
)
